import { useGetCustomLevelsForOrganisationQuery } from '@/app/redux/endpoints/customLevels';
import { useCurrentOrganisationId } from '@/app/redux/hooks/organisation';

export function useCustomLevels() {
  const { currentOrganisationId } = useCurrentOrganisationId();
  const skip = !currentOrganisationId;

  const { data: customLevels = [], isLoading, isFetching, error } =
    useGetCustomLevelsForOrganisationQuery(currentOrganisationId!, { skip });

  return { customLevels, isLoading, isFetching, error };
}
